export default {
  path: '/videoMerger',
  name: '/videoMerger',
  component: () => import('../views/videoMerger.vue')
};
